import { render } from "./LeakRulesCreate.vue?vue&type=template&id=a89e8e24"
import script from "./LeakRulesCreate.vue?vue&type=script&lang=js"
export * from "./LeakRulesCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__